import { graphql } from '@teachino/shared-infrastructure';

export const materialAnnotationToolAccessQuery = graphql(`
  query MaterialAnnotationToolAccess($id: String!) {
    materialAnnotationToolAccess(materialIdInput: { id: $id }) {
      token
      expiresAt
    }
  }
`);
